import * as React from 'react';
export const DOSvg = React.forwardRef(function DOSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement(
        'g',
        {
          fillRule: 'nonzero',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#E25950',
          d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#43458B',
          d: 'M2 2h5v5H0V4a2 2 0 0 1 2-2Zm12 12H9V9h7v3a2 2 0 0 1-2 2Z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#FFF',
          d: 'M16 9H9v5H7V9H0V7h7V2h2v5h7z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#EAEEF3',
          d: 'M15 9V7h1v2h-1Zm-8 4h2v1H7v-1ZM7 2h2v1H7V2ZM0 7h1v2H0V7Z',
        }),
      ),
      /*#__PURE__*/ React.createElement('circle', {
        cx: 8,
        cy: 8,
        r: 1,
        fill: '#24B47E',
      }),
    ),
  );
});
DOSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var DO = {
  category: 'flag',
  colorable: false,
  name: 'DO',
  svg: DOSvg,
};
